export default () => ({

    open: false,

    close(focusAfter) {
        this.open = false;
        (focusAfter instanceof HTMLElement) && focusAfter.focus();
    },

    dropdown: {
        ['x-on:keydown.escape.prevent.stop']() {
            this.close(this.$refs.button);
        },
        ['x-on:focusin.window']($event) {
            return !this.$refs.panel.contains($event.target) && this.close();
        },
        ['x-id']() {
            return ['dropdown-button'];
        },
    },

    trigger: {
        ['x-ref']: 'trigger',
        ['x-on:click']() {
            this.open = true;
        },
        ['x-bind:aria-expanded']() {
            return this.open;
        },
        ['x-bind:aria-controls']() {
            return this.$id('dropdown-button');
        },
    },

    panel: {
        ['x-ref']: 'panel',
        ['x-show']() {
            return this.open;
        },
        ['x-transition.origin.top.right']() {

        },
        ['x-on:click.outside']() {
            this.close(this.$refs.trigger);
        },
        ['x-bind:id']() {
            return this.$id('dropdown-button');
        },
    },
})
